import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class EpicNewsListHeader extends Vue {
    public title: string = 'EpicNewsListHeader';

    @Prop({ default: '' })
    public prefix: any;
    public newsTypeList: {name: string; key: string}[] = [{
        name: 'All',
        key: 'all'
    }, {
        name: 'Real Estate',
        key: 'rifo_web_real_estate'
    }, {
        name: 'Finance',
        key: 'rifo_web_finance'
    }, {
        name: 'Event',
        key: 'rifo_web_event'
    }, {
        name: 'Explore',
        key: 'rifo_web_explore'
    }, {
        name: 'Story',
        key: 'rifo_web_story'
    }];
}
